<form [formGroup]="form" class="form">
  <textarea
    appPasteStrip
    appTextareaAutosize
    appTextareaAutosizeMinRows="5"
    appTextareaAutosizeMaxRows="18"
    class="note-textarea"
    formControlName="note"
    placeholder="Enter Medical Note"
    rxFormControlError
  ></textarea>
</form>
